module.exports = __webpack_public_path__ + "img/drawing2.d04c3611.png";